<template>
  <div class="d-flex flex-column justify-content-center full-height">
    <div class="text-center mb-4">
      <img
        class="logix-icon"
        src="/img/logix.png"
      >
    </div>
    <div
      v-if="pinRequired && haveCard && !urlIncorrect"
      key="pinscreen"
    >
      <div
        class="text-center d-flex justify-content-center"
        style="min-height: 60px"
      >
        <div
          v-if="hiddenpin.length > 0 && !pending"
          class="pin"
        >
          &nbsp;{{ hiddenpin }}&nbsp;
        </div>
        <div style="font-size: 40px">
          <Loader
            v-if="pending"
            class="pin-loader"
            size="30px"
          />
          <div
            v-else-if="error"
            key="error"
            class="text-danger pin-loader"
          >
            <i
              class="fas fa-times"
              style="line-height: 50px"
            />
            {{ $t('invalidPassword') }}
          </div>
        </div>
      </div>
      <div class="w-100 d-flex justify-content-center">
        <div class="pin-box">
          <div class="row justify-content-center">
            <div
              v-for="i in [1,2,3,4,5,6,7,8,9]"
              :key="i"
              class="col-4"
            >
              <p
                class="key"
                @click="add(i)"
              >
                {{ i }}
              </p>
            </div>
            <div class="col-4">
              <p
                class="key"
                @click="haveCard = false; cardCode = ''"
              >
                <i class="fas fa-credit-card" />
              </p>
            </div>
            <div class="col-4">
              <p
                class="key"
                @click="add(0)"
              >
                0
              </p>
            </div>
            <div class="col-4">
              <p
                class="key"
                @click="backspace"
              >
                <i class="fas fa-backspace" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="!urlIncorrect"
      key="usecard"
    >
      <div class="text-center">
        <i
          class="fas fa-credit-card"
          style="font-size: 90px"
        />
        <div
          class="pin"
          style="min-height: 60px"
        >
          &nbsp;{{ hiddenCardNum }}&nbsp;
        </div>
        <div v-if="cardCode.length > 0">
          <button
            class="btn btn-outline-secondary icon-button"
            style="font-size: 35px;height: 60px; width: 60px;"
            @click="cardCode = ''"
          >
            <i class="fas fa-times" />
          </button>
        </div>
        <div
          v-else
          style="font-size: 45px;"
        >
          {{ $t('useCard') }}
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-center"
    >
      <h3>{{ $t('logged') }}</h3>
      <p>{{ $t('urlIncorrect') }}</p>
    </div>

    <div
      class="card-login-icon"
      @click="toLogin"
    >
      <i class="fas fa-sign-in-alt" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    pin: '',
    pinLength: 4,
    pending: false,
    error: null,
    haveCard: false,
    cardInput: null,
    cardCode: '',
    attempt: 0,
    urlIncorrect: false,
  }),
  computed: {
    hiddenpin() {
      return ''.padStart(this.pin.length, '*');
    },
    hiddenCardNum() {
      return ''.padStart(this.cardCode.length, '*');
    },
    pinRequired() {
      return window.sessionStorage.REQUIRE_PIN !== 'False';
    },
  },
  watch: {
    pin() {
      this.checkPin();
    },
  },
  mounted() {
    document.addEventListener('keydown', this.keyDown);
  },
  destroyed() {
    document.removeEventListener('keydown', this.keyDown);
  },
  methods: {
    toLogin() {
      window.location.href = '/';
    },
    add(i) {
      if (this.pending || this.pin.length >= this.pinLength) return;
      this.error = false;
      this.pin = `${this.pin}${i}`;
    },
    backspace() {
      if (this.pending) return;
      this.pin = this.pin.substring(0, this.pin.length - 1);
    },
    login() {
      const queryParams = new URLSearchParams(window.location.search);
      const data = {
        cardId: this.cardCode,
        pin: this.pinRequired ? this.pin : null,
        ReturnUrl: queryParams.get('ReturnUrl'),
      };
      return axios.post('/Account/CardLogin', data);
    },
    defaultLog() {
      this.pending = true;
      this.login()
        .then(({ data: { redirect, invalidUrl } }) => {
          this.pending = false;
          if (invalidUrl) {
            this.urlIncorrect = true;
            return;
          }
          window.location.replace(redirect);
        })
        .catch(() => {
          this.pending = false;
          this.error = true;
          this.pin = '';

          setTimeout(() => {
            if (this.attempt === 2) {
              this.error = false;
              this.attempt = 0;
              this.haveCard = false;
              this.cardCode = '';
            }
          }, 500);
        });
    },
    checkPin() {
      if (this.pin.length === 4) {
        this.attempt += 1;

        this.defaultLog();
      }
    },
    keyDown(e) {
      if (this.haveCard) return;
      if (e.keyCode === 13) {
        this.haveCard = true;
        if (!this.pinRequired) {
          this.defaultLog();
        }
      }
      if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90)) {
        this.cardCode = `${this.cardCode}${e.key}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  .logix-icon {
    max-height: 100px;
    margin: 0 auto 20px;
  }

  .card-login-icon {
    position: absolute;
    bottom: 10px;
    right: 25px;
    font-size: 30px;
    cursor: pointer;
    transition: transform 300ms;
    &:hover {
      transform: scale(1.2);
    }
  }

  .pin-box {
    border: 1px solid rgba(100, 100, 100, 0.2);
    padding: 4px;
    border-radius: 30px;
    max-width: 250px;
    margin: auto;

    .key {
      cursor: pointer;
      display: block;
      background-color: rgba(100,100,100,0.2);
      font-size: 26px;
      font-weight: normal;
      border-radius: 50%;
      margin: 5px auto;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .key:active {
      background-color: rgba(#75af34, 0.3);
    }

  }
  .pin {
    font-size: 35px;
    position: relative;

    .pin-loader {
      position: absolute;
      top: -12px;
      right: -20px;
    }
  }

  .full-height {
    height: 100vh;
  }
</style>
